import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';

export default class ComplianceController extends Controller {
  @service router!: Services['router'];

  get reactPath(): string {
    const path = this.router.currentRoute?.params?.['path'];

    return typeof path === 'string' ? path : '';
  }

  @action
  navigate(path: string): void {
    if (path) {
      this.router.transitionTo('compliance.embed', path);
    } else {
      this.router.transitionTo('compliance');
    }
  }
}
